@import "/src/styles/mixins.sass"

.container
    flex-grow: 1
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    gap: 1rem

    input
        height: 0 !important

    a, label, button
        width: 100%
        max-width: 20rem

.uploadButton
    height: 6rem

.createButton
    height: 15rem
